// Mọi lời gọi mạng của giao diện. /api/* đi qua cổng phiên (functions/_middleware.ts).
export class LoiApi extends Error {
  constructor(public ma: number, public ten: string, public chi_tiet?: string) {
    super(chi_tiet || ten);
  }
}

let khiHetPhien: (() => void) | null = null;
export const datKhiHetPhien = (f: () => void) => { khiHetPhien = f; };

async function goi<T>(duong: string, init: RequestInit & { raw?: boolean } = {}): Promise<T> {
  const { raw, ...con_lai } = init;
  const headers: Record<string, string> = { ...(con_lai.headers as Record<string, string>) };
  if (con_lai.body && !headers['content-type']) headers['content-type'] = 'application/json';
  const r = await fetch(duong, { ...con_lai, headers, credentials: 'same-origin' });
  if (r.status === 401 && !duong.endsWith('/dang-nhap')) khiHetPhien?.();
  if (!r.ok) {
    let ten = 'loi';
    let chi_tiet = '';
    try {
      const j = await r.json();
      ten = j.loi || ten;
      chi_tiet = j.chi_tiet || j.message || '';
    } catch {
      chi_tiet = r.statusText;
    }
    throw new LoiApi(r.status, ten, chi_tiet);
  }
  if (r.status === 204) return null as T;
  return (raw ? r.text() : r.json()) as Promise<T>;
}

const body = (b: unknown) => (b === undefined ? undefined : JSON.stringify(b));

export const api = {
  /** `signal` tuỳ chọn (AbortController): huỷ được yêu cầu treo — nơi hỏi theo nhịp (vclaw-phong-hook) dùng để không kẹt mãi. */
  get: <T>(d: string, tuy_chon?: { signal?: AbortSignal }) => goi<T>('/api/' + d, tuy_chon?.signal ? { signal: tuy_chon.signal } : {}),
  post: <T>(d: string, b?: unknown) => goi<T>('/api/' + d, { method: 'POST', body: body(b) }),
  put: <T>(d: string, b: unknown) => goi<T>('/api/' + d, { method: 'PUT', body: body(b) }),
  patch: <T>(d: string, b: unknown) => goi<T>('/api/' + d, { method: 'PATCH', body: body(b) }),
  del: <T>(d: string) => goi<T>('/api/' + d, { method: 'DELETE' }),
};

export const KHO = 'oyj3000/VTask';

// Proxy GitHub (token ở server). Comment KHÔNG đi đường này — dùng api.post('viec/<so>/binh-luan').
// GET có ETag: GitHub trả 304 cho dữ liệu không đổi, và 304 KHÔNG trừ vào hạn mức 5 000 lượt/giờ của
// token (dùng chung cho cả nhóm). Nhớ ETag + dữ liệu theo đường dẫn, gửi If-None-Match lần sau.
const bo_nho_etag = new Map<string, { etag: string; du_lieu: unknown }>();
// Đăng xuất → xoá: dữ liệu của người trước (vd Wiki.CaNhan chỉ thành viên đọc được) không nằm lại trong tab.
export const xoaBoNhoEtag = () => bo_nho_etag.clear();

async function getCoEtag<T>(duong: string): Promise<T> {
  const cu = bo_nho_etag.get(duong);
  const r = await fetch(duong, { credentials: 'same-origin', headers: cu ? { 'if-none-match': cu.etag } : {} });
  if (r.status === 304 && cu) return cu.du_lieu as T;
  if (r.status === 401) khiHetPhien?.();
  if (!r.ok) {
    let ten = 'loi';
    let chi_tiet = '';
    try { const j = await r.json(); ten = j.loi || ten; chi_tiet = j.chi_tiet || j.message || ''; } catch { chi_tiet = r.statusText; }
    throw new LoiApi(r.status, ten, chi_tiet);
  }
  const du_lieu = (await r.json()) as T;
  const etag = r.headers.get('etag');
  if (etag) bo_nho_etag.set(duong, { etag, du_lieu });
  if (bo_nho_etag.size > 400) bo_nho_etag.delete(bo_nho_etag.keys().next().value!);
  return du_lieu;
}

export const gh = {
  get: <T>(d: string) => getCoEtag<T>('/api/github/' + d),
  raw: (d: string) => goi<string>('/api/github/' + d, { raw: true, headers: { accept: 'application/vnd.github.raw+json' } }),
  post: <T>(d: string, b: unknown) => goi<T>('/api/github/' + d, { method: 'POST', body: body(b) }),
  patch: <T>(d: string, b: unknown) => goi<T>('/api/github/' + d, { method: 'PATCH', body: body(b) }),
};

const BANG_LOI: Record<string, string> = {
  'sai-thong-tin': 'Email hoặc mật khẩu không đúng.',
  'khong-du-quyen': 'Tài khoản của bạn không có quyền làm việc này.',
  'tam-khoa': 'Sai quá nhiều lần — thử lại sau 15 phút.',
  'email-da-co': 'Email này đã có tài khoản.',
  'sai-mat-khau-cu': 'Mật khẩu hiện tại không đúng.',
  'chua-dang-nhap': 'Phiên đăng nhập đã hết — đăng nhập lại.',
  'khong-tu-sua': 'Không tự đổi vai trò hay khoá chính mình.',
  'github-token': 'Token GitHub của máy chủ hỏng hoặc hết hạn — báo quản trị viên cập nhật secret GITHUB_TOKEN.',
  'chi-tao-nhan-tag': 'Chỉ tạo được tag dạng chữ thường không dấu.',
  'github-mang': 'Chưa kết nối được GitHub — thử lại sau ít giây.',
  'loi-may-chu': 'Máy chủ gặp lỗi tạm thời — thử lại sau ít giây.',
  'ngoai-pham-vi': 'Mục này nằm ngoài phạm vi thương hiệu của bạn.',
  'khong-thay': 'Không tìm thấy — việc không tồn tại hoặc không thuộc thương hiệu của bạn.',
  'chi-viec-cua-ban': 'Chỉ sửa được việc được giao cho bạn hoặc do bạn tạo.',
  'brand-sai': 'Tên thương hiệu không hợp lệ.',
  'thu-muc-khong-rong': 'Thư mục còn tài liệu hoặc thư mục con — chuyển / xoá chúng trước.',
  'thu-muc-sai': 'Thư mục không còn hoặc không thuộc brand / thư mục chuẩn đã chọn.',
  'han-ra-soat-sai': 'Hạn rà soát phải là ngày (YYYY-MM-DD).',
  // Addon Thống kê (#542)
  'chua-ket-noi': 'Chưa kết nối Google: quản trị viên cần thêm khoá tài khoản dịch vụ (secret GA_SERVICE_ACCOUNT_JSON).',
  'chua-cap-quyen-property': 'Tài khoản dịch vụ chưa được cấp quyền Người xem trên property GA4 này — nhờ quản trị viên thêm email tài khoản dịch vụ vào GA4.',
  'chua-bat-data-api': 'Chưa bật “Google Analytics Data API” trong dự án Google Cloud của khoá — quản trị viên bật rồi chờ vài phút (mục Kết nối & nguồn → Kiểm tra kết nối cho biết chi tiết).',
  'chua-bat-gsc-api': 'Chưa bật “Google Search Console API” trong dự án Google Cloud của khoá — quản trị viên bật rồi chờ vài phút.',
  'gsc-chua-cap-quyen': 'Tài khoản chưa có quyền với site này trong Search Console — thêm email tài khoản dịch vụ (hoặc email đã kết nối) vào Search Console → Cài đặt → Người dùng và quyền.',
  'gsc-thieu-pham-vi': 'Tài khoản Google đã kết nối chưa cấp quyền Search Console — ở Kết nối & nguồn bấm “+ Search Console” cạnh tài khoản đó để cấp thêm.',
  'gsc-chua-du-lieu': 'Search Console chậm khoảng 3 ngày — kỳ đã chọn chưa có số liệu; chọn kỳ dài hơn hoặc kết thúc sớm hơn.',
  'ma-site-sai': 'Site Search Console không hợp lệ: dạng sc-domain:ten-mien.vn hoặc địa chỉ đầy đủ có dấu / ở cuối.',
  'het-han-muc-google': 'Google Analytics tạm hết hạn mức truy vấn — thử lại sau ít phút.',
  'google-loi': 'Google Analytics trả lỗi — thử lại sau ít phút.',
  'google-tu-choi-khoa': 'Google từ chối khoá tài khoản dịch vụ — kiểm tra lại secret GA_SERVICE_ACCOUNT_JSON.',
  'khoang-qua-dai': 'Khoảng ngày tối đa 400 ngày.',
  'khoang-tuong-lai': 'Ngày kết thúc không được ở tương lai.',
  'khoang-dao-nguoc': 'Ngày bắt đầu phải trước ngày kết thúc.',
  'ma-sai': 'Mã nguồn không hợp lệ.',
  'da-co': 'Nguồn này đã được khai.',
  'chua-bat-admin-api': 'Chưa bật “Google Analytics Admin API” trong dự án Google Cloud (cần để tự liệt kê property) — bật rồi thử lại, hoặc nhập Property ID thủ công.',
  'google-het-quyen': 'Tài khoản Google đã thu hồi hoặc hết hạn quyền — bấm “Kết nối lại” ở mục Tài khoản Google.',
  'oauth-sai-client': 'Google không nhận Client ID / Client secret — kiểm tra hai secret GOOGLE_OAUTH_CLIENT_ID và GOOGLE_OAUTH_CLIENT_SECRET (dán đủ, không thừa dấu cách, đúng client chưa bị xoá) rồi chạy lại deploy.',
  'oauth-sai-redirect': 'URI chuyển hướng chưa khớp — thêm đúng địa chỉ …/api/thong-ke/oauth/callback của trang này vào “URI chuyển hướng được phép” của OAuth client (Google Cloud → Thông tin xác thực).',
  'oauth-ma-het-han': 'Mã đăng nhập Google đã dùng hoặc hết hạn — bấm “Kết nối tài khoản Google” làm lại từ đầu.',
  'oauth-doi-ma-loi': 'Google không đổi được mã đăng nhập — thử kết nối lại; nếu vẫn lỗi, đọc lời Google đi kèm.',
  'oauth-lam-moi-loi': 'Google từ chối làm mới quyền của tài khoản đã kết nối — bấm “Kết nối lại”; nếu vẫn lỗi, kiểm tra Client ID / Client secret.',
  'chua-co-oauth': 'Chưa cấu hình đăng nhập Google (GOOGLE_OAUTH_CLIENT_ID / GOOGLE_OAUTH_CLIENT_SECRET).',
  'thieu-khoa-ma-hoa': 'Chưa có secret ENCRYPTION_KEY để mã hoá token.',
  'khong-giai-ma-duoc': 'Không giải mã được token đã lưu (ENCRYPTION_KEY đã đổi?) — kết nối lại tài khoản Google.',
  'tai-khoan-sai': 'Tài khoản Google đã chọn không tồn tại.',
  'tai-khoan-dang-dung': 'Còn nguồn đang dùng tài khoản này — đổi hoặc xoá các nguồn đó trước.',
  'brand-khong-co-trong-he-thong': 'Có brand không còn trong hệ thống (nhãn brand:…). Bỏ chọn brand đó hoặc tạo nhãn brand trước.',
  'brands-sai': 'Danh sách brand không hợp lệ (slug chữ/số/gạch ngang; tên miền lọc không có khoảng trắng hay dấu /).',
};

export const thongDiepLoi = (e: unknown): string => {
  if (e instanceof LoiApi) return BANG_LOI[e.ten] || e.chi_tiet || e.ten;
  return e instanceof Error ? e.message : String(e);
};
